import { getLogger } from '../observability/logging';
import { type ProductBySlugResponse } from '../product/aliases';
import { type Preview } from '../product/types';

import { type PictureData } from './types';

export function getLargestPictureFormatFromObject(picture: Preview) {
  const keys = Object.keys(picture).map(Number);
  const largest = Math.max(...keys) as keyof Preview;
  return picture[largest];
}

export function getPictureFormatOrFallback({
  pictureData,
  desiredFormat,
}: {
  // Only `formats` is read, so `id` stays optional to accept picture data
  // from presentation-api as well as the local PictureData shape.
  pictureData?: { id?: number; formats: PictureData['formats'] };
  desiredFormat: string;
}) {
  if (
    !pictureData ||
    !pictureData.formats ||
    !Object.keys(pictureData.formats).length
  ) {
    return '';
  }
  if (pictureData.formats[desiredFormat]) {
    return pictureData.formats[desiredFormat].url;
  }
  getLogger().info(`Picture Error - missing requested format`, {
    error: `${desiredFormat} does not exist on picture data`,
  });
  return pictureData.formats[Object.keys(pictureData.formats)[0]].url;
}

export function getAltText(product?: ProductBySlugResponse) {
  if (!product) {
    return '';
  }
  if (product.seller?.username) {
    return `item listed by ${product.seller.username}`;
  }
  if (product.brand_name) {
    return `item from brand ${product.brand_name}`;
  }
  return '';
}
